import {Text } from "@fluentui/react-northstar";

const LabelBox = ({ label }) => {
  return (
    <div
      style={{
        backgroundColor: "#f2f2f2",
        padding:"0 5px"
      }}
    >
      <Text
        content={label}
        truncated
        title={label}
        weight="semibold"
      />
    </div>
  );
};

export default LabelBox;
